module.exports = __webpack_public_path__ + "static/5-c4c44c0e1746768662575f6c4157569e.png";